import { Card } from "@clipboard-health/ui-components";
import { CardContent, Skeleton, Stack } from "@mui/material";

interface ReferenceCardSkeletonProps {
  completed?: boolean;
}

export function ReferenceCardSkeleton({ completed = false }: ReferenceCardSkeletonProps) {
  return (
    <Card
      outlined
      variant="tertiary"
      sx={{ p: 2 }}
      role="progressbar"
      aria-label="Loading reference"
    >
      <CardContent>
        <Stack spacing={5}>
          {/* Status pill skeleton */}
          <Skeleton variant="rounded" width={80} height={24} />

          {/* Reference name skeleton */}
          <Skeleton variant="text" width="50%" height={28} />

          {/* Employer section skeleton */}
          <Stack gap={1}>
            <Skeleton variant="text" width="30%" height={16} />
            <Stack>
              <Skeleton variant="text" width="70%" height={28} />
              <Skeleton variant="text" width="50%" height={14} />
            </Stack>
          </Stack>

          {/* Date sent section skeleton */}
          {!completed && (
            <Stack gap={1}>
              <Skeleton variant="text" width="30%" height={16} />
              <Skeleton variant="text" width="40%" height={28} />
            </Stack>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
}
